export default __webpack_public_path__ + "static/media/player_3_2.15dae198.png";